import { BufferTrackerReact as BufferTracker } from '@buffer-mono/tracking-plan'

import { shouldPerformTrackingEvent } from '../utils'
import { getOrganization } from '../../common/utils/user'
import type { TrackFeatureTrialPathsArguments } from './FeatureTrialPathsTrackingTypes'

export default function trackFeatureTrialModalViewed({
  payload,
  user,
}: TrackFeatureTrialPathsArguments): void {
  const canPerformTrackingEvent = shouldPerformTrackingEvent({
    user,
  })

  if (!canPerformTrackingEvent) {
    return
  }

  const { feature, cta } = payload

  const organization = getOrganization(user)

  BufferTracker.featureSpecificTrialModalViewed({
    organizationId: organization?.id || '',
    clientName: 'publishWeb',
    cta: cta || '',
    feature,
  })
}
